import React, { useEffect, useState } from "react";
import { axiosGetUnAuth, axiosPost } from "../../../utils/AxiosApi";
import ModalWindow from "../../UI/ModalWindow";
import CalendarForm from "./CalendarForm";
import { displayConfirmDeleteAlert, displayErrorAlert, displayMessage } from "../../../utils/Utils";
import { URL } from "../../../utils/Constants";
import swal from "sweetalert";
import moment from "moment";
import { getCalendarEvents } from "../../../ducks/AcademicAdministrationDucks";
import { connect } from "react-redux";
import { Spinner } from "reactstrap";
import Tooltip from '@material-ui/core/Tooltip';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";

const NewNepaliCalendar = (props) => {
    const [currentMonth, setCurrentMonth] = useState();
    const [currentYear, setCurrentYear] = useState();

    const [npCalendarData, setNpCalendarData] = useState([]);
    // for month and year values for header in nepali
    const [currentMonthVal, setCurrentMonthVal] = useState("");
    const [currentYearVal, setCurrentYearVal] = useState("");
    // for month and year values for header in english
    const [currentEngMonthVal, setCurrentEngMonthVal] = useState("");
    const [currentEngYearVal, setCurrentEngYearVal] = useState("");
    const [currentEngMonthEndVal, setCurrentEngMonthEndVal] = useState("");

    // for calendar modal
    const [modal, setModal] = useState(false);
    const [action, setAction] = useState("add");
    const [educationLevels, setEducationLevels] = useState([]);
    const [selectedItems, setSelectedItems,] = useState(null);

    // calendar form state values
    const [calendarTitle, setCalendarTitle] = useState("");
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [colorCode, setColorCode] = useState("");
    const [isHoliday, setIsHoliday] = useState(false);
    const [eventType, setEventType] = useState("");
    const [description, setDescription] = useState("");
    const [educationLevelId, setEducationLevelId] = useState(0);
    const [updateId, setUpdateId] = useState("");
    const [checked, setChecked] = useState(false);

    const [currentAcYr, setCurrentAcYr] = useState("");
    const [currentAcYrId, setCurrentAcYrId] = useState("");
    const [currentAcYrName, setCurrentAcYrName] = useState("");
    const [eventNameError, setEventNameError] = useState(false);
    const [educationLevelIdMultiple, setEducationLevelIdMultiple] = useState("0");
    const [selectHolidayOption, setSelectHolidayOption] = useState([]);
    const [holidaysOption, setHolidaysOption] = useState([]);
    const [selectedEvent, setSelectedEvent] = useState([]);
    const [unfilteredEvents, setUnfilteredEvents] = useState([]);
    const [uniqueCalendarEvents, setUniqueCalendarEvents] = useState([]);
    const [widgetEvents, setWidgetEvents] = useState([]);


    const [showSpinner, setShowSpinner] = useState(false);


    useEffect(() => {
        const calendarLink = "https://calendar.techarttrekkies.com.np/json";
        setShowSpinner(true);
        axiosGetUnAuth(calendarLink, (response) => {
            if (response) {
                const adYear = response?.data?.ad_y;
                const adMonth = response?.data?.month_name;
                const bsYear = response?.data?.unicode?.bs_y;
                const bsMonth = response?.data?.unicode?.month_name;
                const bsDay = response?.data?.bs_d;

                setCurrentYear(response?.data?.bs_y);
                setCurrentMonth(response?.data?.bs_m)
                setCurrentYearVal(bsYear);
                setCurrentMonthVal(bsMonth);
                setCurrentEngMonthVal(adMonth);
                setCurrentEngYearVal(adYear);

                axiosGetUnAuth(`https://calendar.techarttrekkies.com.np/${response?.data?.bs_y}/${response?.data?.bs_m}/json`, (resp) => {
                    if (resp) {
                        setShowSpinner(false);
                        const nepaliCalendarData = resp?.data?.calendarData;
                        if (nepaliCalendarData && nepaliCalendarData?.length > 0) {
                            setCurrentEngMonthEndVal(nepaliCalendarData?.[nepaliCalendarData?.length - 1]?.month_name);
                            setNpCalendarData(nepaliCalendarData);
                        }
                    }
                    else {
                        setShowSpinner(false);
                    }
                })
            }
        });

        getUserCurrentAcademicYear();
        getEducationLevel();
        getHolidays();
        getWidgetEvents();
    }, []);


    const newLinkCalendarData = (year, month) => {

        axiosGetUnAuth(`https://calendar.techarttrekkies.com.np/${year}/${month}/json`, (resp) => {
            if (resp) {
                const nepaliCalendarData = resp?.data?.calendarData;
                setNpCalendarData(nepaliCalendarData);
                setCurrentEngMonthEndVal(nepaliCalendarData?.[nepaliCalendarData?.length - 1]?.month_name);
            }

        })

    }

    const handlePrevBtnCLick = () => {
        let month = currentMonth - 1;
        let year = currentYear;

        setCurrentMonth(month);
        if (month === 0) {
            month = 12;
            setCurrentMonth(month);
            year = currentYear - 1;
            setCurrentYear(year);
            newLinkCalendarData(year, month);
        }
        else {
            newLinkCalendarData(currentYear, month);
        }
    }

    const handleNextBtnCLick = () => {
        let month = currentMonth + 1;
        let year = currentYear;

        setCurrentMonth(month);
        if (month === 13) {
            month = 1;
            setCurrentMonth(month);
            year = currentYear + 1;
            setCurrentYear(year);
            newLinkCalendarData(year, month);
        }
        else {
            newLinkCalendarData(currentYear, month);
        }
    }

    useEffect(() => {
        if (npCalendarData?.length > 0) {
            setCurrentYearVal(npCalendarData?.[0]?.unicode?.bs_y)
            setCurrentMonthVal(npCalendarData?.[0]?.unicode?.month_name)
            setCurrentEngYearVal(npCalendarData?.[0]?.ad_y)
            setCurrentEngMonthVal(npCalendarData?.[0]?.month_name)
        }
    }, [npCalendarData]);

    const weekdayToIndex = {
        Sunday: 0,
        Monday: 1,
        Tuesday: 2,
        Wednesday: 3,
        Thursday: 4,
        Friday: 5,
        Saturday: 6,
    };

    const blanksCount = npCalendarData && npCalendarData.length > 0
        ? weekdayToIndex[npCalendarData[0].week_day] || 0
        : 0;

    const dayMapping = {};
    npCalendarData.forEach((day) => {
        dayMapping[day.week_day] = day.unicode.week_day;
    });

    const daysOfWeek = [
        { key: 'sunday', name: 'Sunday', nepaliDay: dayMapping['Sunday'] },
        { key: 'monday', name: 'Monday', nepaliDay: dayMapping['Monday'] },
        { key: 'tuesday', name: 'Tuesday', nepaliDay: dayMapping['Tuesday'] },
        { key: 'wednesday', name: 'Wednesday', nepaliDay: dayMapping['Wednesday'] },
        { key: 'thursday', name: 'Thursday', nepaliDay: dayMapping['Thursday'] },
        { key: 'friday', name: 'Friday', nepaliDay: dayMapping['Friday'] },
        { key: 'saturday', name: 'Saturday', nepaliDay: dayMapping['Saturday'] },
    ];

    const weeks = [];
    let currentWeek = new Array(blanksCount).fill(null);
    npCalendarData.forEach((day) => {
        currentWeek.push(day);
        if (currentWeek.length === 7) {
            weeks.push(currentWeek);
            currentWeek = [];
        }
    });
    // Push last week if it has days but is incomplete
    if (currentWeek.length > 0) {
        while (currentWeek.length < 7) {
            currentWeek.push(null);
        }
        weeks.push(currentWeek);
    }

    const handleDateClick = (date) => {
        setModal(!modal);
        setStartDate(moment(date?.long_format).format("YYYY-MM-DD"));
        setEndDate(moment(date?.long_format).format("YYYY-MM-DD"));
    }

    const getUserCurrentAcademicYear = () => {
        axiosPost(URL.selectUserAcademicYear, {}, (response) => {
            if (response.status === 200) {
                if (response.data.data) {
                    setCurrentAcYr(response.data.data);
                    setCurrentAcYrId(response.data.data.academicYearId);
                    setCurrentAcYrName(response.data.data.academicYearName);
                } else {
                    getCurrentAcademicYear();
                }
            }
        });
    };

    const getEducationLevel = () => {
        axiosPost(URL.getEducationLevel, {}, (response) => {
            if (response.status === 200) {
                setEducationLevels(response.data.data);
                let selectedItems = [...response.data.data];
                selectedItems.forEach((level) => {
                    level.label = level.name;
                    level.value = level.id;
                });
                setSelectedItems(selectedItems)
            }
        });
    };

    const getCurrentAcademicYear = () => {
        let data = {
            isCurrent: "true",
        };

        axiosPost(URL.getAcademicYears, data, (response) => {
            if (response.status === 200) {
                setCurrentAcYr(response.data.data[0]);
                setCurrentAcYrId(response.data.data[0].id);
                setCurrentAcYrName(response.data.data[0].name);
            }
        });
    };

    const getWidgetEvents = () => {
        axiosPost(URL.getEvents, {}, async (responseWidgets) => {
            if (responseWidgets.status === 200) {
                axiosPost(URL.getWeekDaysByEduDiv, {}, (response) => {
                    if (response.status === 200) {
                        const weekDays = [0, 1, 2, 3, 4, 5, 6];
                        const days = response.data.data.map(({ id }) => id);
                        let filteredDays = weekDays.filter((el) => !days.includes(el));
                        let anEvent = [];
                        anEvent.push({
                            daysOfWeek: filteredDays,
                            rendering: "background",
                            color: `#668ef5`,
                            overLap: false,
                            allDay: true,
                        });

                        let newEvents = [...responseWidgets.data.data];

                        setUnfilteredEvents(newEvents);


                        newEvents.forEach((event) => {
                            event.end = new Date(event.end).toISOString();
                        });
                        setWidgetEvents(newEvents)
                        const events = newEvents;
                        const unique = [];
                        events.map((x) =>
                            unique.filter(
                                (a) =>
                                    a.color == x.color &&
                                    a.title == x.title &&
                                    a.start == x.start &&
                                    a.end == x.end
                            ).length > 0
                                ? null
                                : unique.push(x)
                        );
                        setUniqueCalendarEvents(unique);
                    }
                });
            }
        });
    };

    const handleEventForm = () => {
        return (
            <CalendarForm
                create={true}
                startDate={startDate}
                endDate={endDate}
                selectHolidayOption={selectHolidayOption}
                calendarTitle={calendarTitle}
                handleChangeEvent={handleChangeEvent}
                description={description}
                closeModal={closeModal}
                checked={checked}
                educationLevelId={educationLevelId}
                educationLevelIdMultiple={educationLevelIdMultiple}
                educationLevels={educationLevels}
                // handleEducationLevelChange={handleEducationLevelChange}
                action={action}
                showSpinner={showSpinner}
                eventNameError={eventNameError}
                handleChange={handleChange}
                selectedEvent={selectedEvent}
                isHoliday={isHoliday}
                colorCode={colorCode}
                maxEndDate={currentAcYr.endDate}
            ></CalendarForm>
        );
    };

    const updateEventForm = () => {
        return (
            <CalendarForm
                create={false}
                submit={updateCalendar}
                closeModal={closeModal}
                checked={checked}
                calendarTitle={calendarTitle}
                handleChangeEvent={handleChangeEvent}
                handleChange={handleChange}
                startDate={startDate}
                endDate={endDate}
                description={description}
                educationLevels={educationLevels}
                educationLevelIdMultiple={educationLevelIdMultiple}
                // handleEducationLevelChange={handleEducationLevelChange}
                action={action}
                showSpinner={showSpinner}
                selectHolidayOption={selectHolidayOption}
                selectedEvent={selectedEvent}
                colorCode={colorCode}
                isHoliday={isHoliday}
                maxEndDate={currentAcYr.endDate}
            ></CalendarForm>
        );
    };

    const closeModal = (e) => {
        setShowSpinner(false);
        setModal(!modal);
        setAction("add");
        setCalendarTitle("");
        setStartDate("");
        setEndDate("");
        setDescription("");
        setUpdateId("");
        setChecked(false);
        setEducationLevelId(0);
        setColorCode("");
        setSelectedEvent("")
    };

    const getData = (color, isHoliday, eventTypeName, educationLevelId) => {
        let newEl = [];

        if (educationLevelIdMultiple === "0") {
            newEl = educationLevels.map((el) => {
                return el.id;
            });
        } else {
            newEl.push(educationLevelIdMultiple);
        }

        let param = [];

        if (action === "add") {
            param.push({
                title: calendarTitle,
                start: moment(startDate).format("YYYY-MM-DD"),
                end: moment(endDate).format("YYYY-MM-DD"),
                educationLevelIds: newEl,
                description: description
                    ? description
                    : "no description",
                color: color,
                isHoliday: isHoliday,
                eventTypeName: eventTypeName,
            });
        } else {
            param = {
                title: calendarTitle,
                start: moment(startDate).format("YYYY-MM-DD"),
                end: moment(endDate).format("YYYY-MM-DD"),
                // educationLevelIds: newEl,
                description: description
                    ? description
                    : "no description",
                color: color,
                isHoliday: isHoliday,
                eventTypeName: eventTypeName,
            };
        }
        return param;
    };

    const submitCalendar = (e) => {
        if (
            calendarTitle === "" ||
            startDate === "" ||
            endDate === "" ||
            isHoliday === "" ||
            colorCode === ""
        ) {
            swal({
                title: "Oops",
                text: "Fill all the necessary fields: Event Name, Start Date and End Date ,Event Type.",
                allowOutsideClick: false,
                closeOnClickOutside: false,
            });
            return false;
        }
        let datas = [];
        let color = colorCode;
        let Holiday = isHoliday;
        let eventTypeName = eventType;
        datas = getData(
            color,
            Holiday,
            eventTypeName,
            educationLevelId
        );
        setShowSpinner(true);
        axiosPost(
            URL.insertEvent,
            datas,
            (response) => {
                if (response.status === 200) {
                    displayMessage("Success", "Events added successfully.", () => {
                        getWidgetEvents();
                        props.getCalendarEvents(
                            props.assessmentModuleandEducationLevel
                        );
                    });
                    setShowSpinner(false);
                    setAction("add")
                    setEducationLevelId(0);
                    setColorCode("");
                    setModal(!modal);
                    setCalendarTitle("");
                    setStartDate("");
                    setEndDate("");
                    setDescription("");
                    setSelectedEvent("")
                    // this.setState({
                    //   holidayChecked: false,
                    //   eventNameError: false,
                    // }, () => {
                    //   this.renderNepaliDates();
                    // });
                }
            },
            (error) => {
                setShowSpinner(false)
                displayErrorAlert(error);
            }
        );
    }


    const updateCalendar = (e) => {

        if (
            calendarTitle === "" ||
            startDate === "" ||
            endDate === ""
        ) {
            swal({
                title: "Oops",
                text: "Fill all the necessary fields: Event Name, Start Date and End Date ,Event Type.",
                allowOutsideClick: false,
                closeOnClickOutside: false,
            });
            return false;
        }

        let chkID = parseInt(updateId);
        const events = [...unfilteredEvents];
        const groupedEvents = {};

        events.forEach((event) => {
            const key = `${event.color}-${event.title}`;

            if (!groupedEvents[key]) {
                groupedEvents[key] = [];
            }

            groupedEvents[key].push(event);
        });

        const unique = Object.values(groupedEvents);

        let sameEvents = [];

        unique.forEach((u) => {
            if (u.find((iu) => iu.id === chkID)) {
                sameEvents.push(u);
            }
        });

        let updateIds = [];
        if (educationLevelIdMultiple === "0") {
            updateIds = sameEvents[0].map((el) => {
                return el.id;
            });
        } else {
            updateIds = sameEvents[0].map((el) => {
                if (el.educationLevelId == educationLevelIdMultiple) {
                    return el.id;
                }
            });
        }

        let newUpdateIds = updateIds.filter((elements) => {
            return elements != null && elements !== undefined && elements !== "";
        });

        let color = colorCode;
        let Holiday = isHoliday;
        let eventTypeName = eventType;
        let datas = getData(
            color,
            Holiday,
            eventTypeName,
            educationLevelId
        );
        datas.ids = newUpdateIds;
        setShowSpinner(true);
        axiosPost(
            URL.updateEvent,
            datas,
            (response) => {
                if (response.status === 200) {
                    swal({
                        title: "Success",
                        text: "Events updated successfully",
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                    });
                    props.getCalendarEvents(
                        props.assessmentModuleandEducationLevel
                    );
                    getWidgetEvents();
                    setShowSpinner(false);
                    setModal(!modal);
                    setAction("add");
                    setCalendarTitle("");
                    setStartDate("");
                    setEndDate("");
                    setDescription("");
                    setUpdateId("");
                    setChecked(false);
                    setEducationLevelId(0);
                    setColorCode("");
                    setSelectedEvent("")
                }
            },
            (error) => {
                setShowSpinner(false);
                let errorResponse = error.response ? error.response.data : error;
                if (errorResponse.status === 400) {
                    //if condition to check spring boot validation errors
                    let errorMessage = "";
                    if (errorResponse.errors) {
                        errorResponse.errors.forEach((error) => {
                            errorMessage += `${error.field
                                .replace(/([A-Z])/g, " $1")
                                .replace(/^./, function (str) {
                                    return str.toUpperCase();
                                })} ${error.defaultMessage} \n`; //ishan
                        });
                        swal(errorResponse.error, errorMessage, "");
                    } else {
                        swal(errorResponse.error, errorResponse.message, "");
                    }
                } else {
                    setShowSpinner(false);
                    swal(
                        errorResponse.error || "Network Error",
                        errorResponse.message
                            ? errorResponse.message
                            : "Could Not Connect To The Server.",
                        ""
                    );
                }
            }
        );
    };

    const calendarFooter = () => {
        return (
            <>
                <button
                    className="tt-button tt-button-primary"
                    type="submit"
                    onClick={() =>
                        action === "add"
                            ? submitCalendar()
                            : updateCalendar()
                    }
                    disabled={educationLevels?.length > 0 ? false : true}
                >
                    {action === "add" ? "Save Event" : "Update Event"}
                </button>
                <button
                    type="reset"
                    className="tt-button tt-button-primary"
                    onClick={() =>
                        action === "add"
                            ? closeModal
                            : () => {
                                displayConfirmDeleteAlert({}, deleteEvent);
                            }
                    }
                >
                    {action === "add" ? "Cancel Event" : "Delete Event"}
                </button>
            </>
        );
    }

    const deleteEvent = () => {

    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "calendarTitle") {
            setCalendarTitle(value);
            // setEventNameError(false);
        }
        if (name === "startDate") {
            setStartDate(value);
            setEndDate("");
        }
        if (name === "endDate") {
            setEndDate(value);
        }
        if (name === "description" && value.length > 0) {
            setDescription(value);
        }
    };

    const handleChangeEvent = (e) => {
        const holidaysOptionCopy = [...holidaysOption];
        let reactSelectEvent = e;
        if (e !== null) {
            setSelectedEvent(reactSelectEvent);

            var selectedVal = [{ ...e }];
            var selectedColor = selectedVal.map((opt) => opt.color);

            holidaysOptionCopy.forEach((el, id) => {
                if (el.colorCode === selectedColor[0]) {
                    setColorCode(el.colorCode);
                    setIsHoliday(el.isHoliday);
                    setEventType(el.eventTypeName);
                }
            });
        }
    };

    const getHolidays = () => {
        axiosPost(URL.getHolidayOptions, {}, (response) => {
            if (response.data.status === 200) {
                const data = response.data.data;
                if (data.length > 0) {
                    setHolidaysOption(data);
                    const selectOptions = data.map((el) => {
                        return {
                            value: el.id,
                            label: el.eventTypeName,
                            color: el.colorCode,
                        };
                    });
                    setSelectHolidayOption(selectOptions)
                    // this.setState({ selectHolidayOption: selectOptions });
                }
            }
        });
    };

    const handleEventClick = (arg) => {
        setModal(!modal);
        setAction("edit");
        setCalendarTitle(arg.title);
        setStartDate(moment(arg.start).format("YYYY-MM-DD"));
        setEndDate(moment(arg.end).format("YYYY-MM-DD"));
        setDescription(arg.description);
        setUpdateId(arg.id);
        setColorCode(arg?.color);
        setEducationLevelId(arg.educationLevelId);


        let eventObj = {};
        eventObj.color = arg?.color;
        eventObj.label = arg?.eventTypeName;
        eventObj.value = arg?.id;
        setSelectedEvent(eventObj)
    }


    return (
        <div className="pt-8 px-4 mx-auto" style={{ textAlign: "center", fontFamily: "'Inter', sans-serif", color: "#374151" }}>
            {/* {console.log(props)} */}
            {showSpinner ?
                (
                    <>
                        <div className="row">
                            <div className="col" style={{ height: "65vh" }}>
                                <div className="d-flex align-items-center justify-content-center flex-column" style={{ height: "100%" }}>
                                    <Spinner color="primary"></Spinner>
                                    <p className="mt-1">
                                        Loading Calendar Data...
                                    </p>
                                </div>
                            </div>
                        </div>
                    </>
                )
                :
                (
                    <>
                        <div className="d-flex justify-content-between  my-1">
                            <button
                                className="fc-prev-button fc-button fc-button-primary ml-0"
                                onClick={handlePrevBtnCLick}
                                aria-label="Previous month"
                            >
                                <FontAwesomeIcon icon={faChevronLeft} />
                            </button>
                            <h3 className="my-1">
                                {`${currentMonthVal},${currentYearVal} (${currentEngMonthVal + "/" + currentEngMonthEndVal},${currentEngYearVal})`}
                            </h3>
                            <button
                                className="fc-next-button fc-button fc-button-primary ml-0"
                                onClick={handleNextBtnCLick}
                                aria-label="Next month"
                            >
                                <FontAwesomeIcon icon={faChevronRight} />
                            </button>
                        </div>
                        {/* table jsx for events */}
                        <table className="table table-bordered" role="grid" aria-label="Nepali Calendar">
                            <thead>
                                <tr className="text-white">
                                    {daysOfWeek.map((day) => (
                                        <th
                                            key={day.key}
                                            scope="col"
                                            className="py-3 px-2 text-center"
                                        >
                                            <div>{day.nepaliDay}</div>
                                            <div>({day.name})</div>
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {weeks.map((week, wi) => (
                                    <tr key={wi} className="">
                                        {week.map((day, di) =>
                                            day ? (
                                                <td
                                                    style={{ height: "125px", width: "150px",border:`${day?.today?"2px solid #126696":""}` }}
                                                    key={day.id}
                                                    tabIndex={0}
                                                    className={`${day?.week_day === "Saturday" ? ` text-danger` : ``}`}
                                                    aria-label={`${day.bs_d} ${currentMonthVal} ${currentYearVal}`}
                                                >
                                                    <div className="d-flex flex-column justify-content-between"
                                                        style={{ height: "100%" }}
                                                        onClick={() => {
                                                            handleDateClick(day)
                                                        }}>
                                                        <p className="m-0 text-right mr-1" style={{ fontSize: "2.5vh" }}>
                                                            {day.unicode?.bs_d || day.bs_d}
                                                        </p>
                                                        <div className="d-flex flex-column justify-content-center">
                                                            {uniqueCalendarEvents
                                                                .filter(event => {
                                                                    const dayDate = moment(day.date_ad).startOf('day'); // parse ISO date of the day cell
                                                                    const eventStart = moment(event.start, "YYYY-MM-DD").startOf('day');
                                                                    const eventEnd = event.end
                                                                        ? moment(event.end).startOf('day')
                                                                        : eventStart;
                                                                    return dayDate.isSameOrAfter(eventStart) && dayDate.isSameOrBefore(eventEnd);
                                                                })
                                                                .map((event, index) => (
                                                                    <div id={`toggle${event.id}`} key={event.id}>
                                                                        <Tooltip
                                                                            placement="top"
                                                                            title={
                                                                                <div style={{ fontSize: '0.9rem', color: "white" }}>
                                                                                    {event?.description}
                                                                                </div>
                                                                            }
                                                                            arrow
                                                                        >
                                                                            <div
                                                                                onClick={(e) => {
                                                                                    e.stopPropagation();
                                                                                    handleEventClick(event);
                                                                                }}
                                                                                key={index} className="mt-1"
                                                                                style={{
                                                                                    backgroundColor: event.color,
                                                                                    borderRadius: "6px",
                                                                                    lineHeight: "1.4",
                                                                                    zIndex: "999999999"
                                                                                }}>
                                                                                <span className="text-left text-white" style={{ fontSize: "1.5vh" }}>
                                                                                    {event.title}
                                                                                </span>
                                                                            </div>
                                                                        </Tooltip>
                                                                    </div>
                                                                ))
                                                            }

                                                        </div>
                                                        <span className="text-left" style={{
                                                        }}>
                                                            {day.ad_d}
                                                        </span>
                                                    </div>
                                                </td>
                                            ) : (
                                                <td key={`blank-${wi}-${di}`} className="py-2 px-2" aria-hidden="true" />
                                            )
                                        )}
                                    </tr>
                                ))}
                            </tbody>
                            {/* <tbody>
  {weeks.map((week, wi) => {
    let skipDays = 0; // Track how many days to skip due to colspan

    return (
      <tr key={wi}>
        {week.map((day, di) => {
          if (skipDays > 0) {
            skipDays--;
            return null; // Skip rendering this day because it is covered by previous colspan
          }

          if (!day) {
            // Empty day cell (blank)
            return <td key={`blank-${wi}-${di}`} className="py-2 px-2" aria-hidden="true" />;
          }

          const dayDate = moment(day.date_ad).startOf('day');

          // Find multi-day event that starts on this day
          const multiDayEvent = uniqueCalendarEvents.find(event => {
            const eventStart = moment(event.start, "YYYY-MM-DD").startOf('day');
            const eventEnd = event.end ? moment(event.end).startOf('day') : eventStart;
            return dayDate.isSame(eventStart) && eventEnd.diff(eventStart, 'days') > 0;
          });

          if (multiDayEvent) {
            const eventStart = moment(multiDayEvent.start, "YYYY-MM-DD").startOf('day');
            const eventEnd = multiDayEvent.end ? moment(multiDayEvent.end).startOf('day') : eventStart;

            // Calculate how many days event spans within this week
            // Get last day of this week row
            const lastDayOfWeek = week
              .filter(Boolean)
              .map(d => moment(d.date_ad).startOf('day'))
              .reduce((max, curr) => (curr.isAfter(max) ? curr : max), moment(0));

            const totalSpan = eventEnd.diff(eventStart, 'days') + 1;
            const daysLeftInWeek = lastDayOfWeek.diff(dayDate, 'days') + 1;
            const spanLength = Math.min(totalSpan, daysLeftInWeek);

            skipDays = spanLength - 1; // Skip the next days covered by colspan

            return (
              <td
                key={day.id}
                colSpan={spanLength}
                style={{
                  height: "125px",
                  width: `${150 * spanLength}px`,
                  backgroundColor: multiDayEvent.color,
                  borderRadius: "6px",
                  lineHeight: "1.4",
                  verticalAlign: "top",
                  cursor: "pointer",
                }}
                tabIndex={0}
                aria-label={`${day.bs_d} ${currentMonthVal} ${currentYearVal}`}
                onClick={() => handleDateClick(day)}
                className={`${day?.week_day === "Saturday" ? `py-2 px-2  text-danger` : `py-2 px-2 `}`}
              >
                <div className="d-flex flex-column justify-content-between" style={{ height: "100%" }}>
                  <p className="m-0 text-right mr-1" style={{ fontSize: "2.5vh" }}>
                    {day.unicode?.bs_d || day.bs_d}
                  </p>
                  <span className="text-left text-white" style={{ fontSize: "1.5vh" }}>
                    {multiDayEvent.title}
                  </span>
                  <span className="text-left">{day.ad_d}</span>
                </div>
              </td>
            );
          }

          // Render normal cell for days without multi-day event start
          // Find single-day events or multi-day events that continue but do not start today
          const dayEvents = uniqueCalendarEvents.filter(event => {
            const eventStart = moment(event.start, "YYYY-MM-DD").startOf('day');
            const eventEnd = event.end ? moment(event.end).startOf('day') : eventStart;
            return dayDate.isSameOrAfter(eventStart) && dayDate.isSameOrBefore(eventEnd)
              && !(dayDate.isSame(eventStart) && eventEnd.diff(eventStart, 'days') > 0);
          });

          return (
            <td
              key={day.id}
              style={{ height: "125px", width: "150px" }}
              tabIndex={0}
              className={`${day?.week_day === "Saturday" ? `py-2 px-2  text-danger` : `py-2 px-2 `}`}
              aria-label={`${day.bs_d} ${currentMonthVal} ${currentYearVal}`}
              onClick={() => handleDateClick(day)}
            >
              <div className="d-flex flex-column justify-content-between" style={{ height: "100%" }}>
                <p className="m-0 text-right mr-1" style={{ fontSize: "2.5vh" }}>
                  {day.unicode?.bs_d || day.bs_d}
                </p>
                <div className="d-flex flex-column justify-content-center">
                  {dayEvents.map((event, index) => (
                    <div key={index} className="mt-1" style={{
                      backgroundColor: event.color,
                      borderRadius: "6px",
                      lineHeight: "1.4"
                    }}>
                      <span className="text-left text-white" style={{ fontSize: "1.5vh" }}>
                        {event.title}
                      </span>
                    </div>
                  ))}
                </div>
                <span className="text-left">{day.ad_d}</span>
              </div>
            </td>
          );
        })}
      </tr>
    );
  })}
</tbody> */}

                        </table>
                    </>
                )}
            <ModalWindow
                fullWidth={false}
                modal={modal}
                toggleModal={closeModal}
                modalHeader={
                    action === "add"
                        ? "Set Calendar Events"
                        : "Update Calendar Events"
                }
                modalBody={
                    action === "add"
                        ? handleEventForm()
                        : updateEventForm()
                }
                modalFooter={calendarFooter()}
            ></ModalWindow>
        </div >
    );
};

const mapStateToProps = (state, props) => ({
    calendarEvents: state.academicAdministration.calendarEvents,
});
const mapActionToProps = {
    getCalendarEvents,
};
export default connect(mapStateToProps, mapActionToProps)(NewNepaliCalendar);
// export default NewNepaliCalendar;
